import { render } from "./Insurers.vue?vue&type=template&id=7d0092a4&scoped=true"
import script from "./Insurers.vue?vue&type=script&lang=js"
export * from "./Insurers.vue?vue&type=script&lang=js"

import "./Insurers.vue?vue&type=style&index=0&id=7d0092a4&scoped=true&lang=css"

import exportComponent from "/Users/alexisbailly/Documents/Programming/Website/vueform/Wealth & Retirement/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-7d0092a4"]])

export default __exports__